export default __webpack_public_path__ + "static/media/phone.ecc96cc9.svg";